



import {Component, Prop, Vue} from 'vue-property-decorator';
import icons, {enumIconName, SvgSymbolData} from '../icons';
import SvgIcon from './SvgIcon.vue';

@Component({components: {SvgIcon}})
export default class EnumIcon extends Vue {
    @Prop({required: true, type: String})
    public dataParameter: string;

    @Prop({required: true, type: String})
    public dataOption: string;

    private get symbolData(): SvgSymbolData {
        const iconName = enumIconName(this.dataParameter, this.dataOption);

        if (! (iconName in icons)) {
            throw new Error(`Icon ${iconName} was not found`);
        }

        return icons[iconName as keyof typeof icons] as SvgSymbolData;
    }
}
